<template>
  <div>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item has-feedback label="Title / Tên chức vụ" prop="name">
        <a-input v-model="form.name" placeholder="Enter title" />
      </a-form-model-item>

      <a-form-model-item has-feedback label="Status" prop="status">
        <a-switch
          @change="onChangePosition"
          checked-children="Active"
          :checked="form.status === 'ACTIVE'"
        />
      </a-form-model-item>
    </a-form-model>

    <div
      style="text-align: right;"
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button @click="closeDrawerAddPosition" style="margin-right: 5px;">
        Close
      </a-button>
      <a-button type="primary" @click="createPosition()" :loading="iconLoading">
        Create
      </a-button>
    </div>
  </div>
</template>
<script>
import postQuery from "../../data/postData";

const defaultForm = { status: "ACTIVE" };

export default {
  props: {
    closeDrawerAddPosition: {
      type: Function,
      default: null,
    },
    createdPositionOnView: {
      type: Function,
    },
  },
  data() {
    return {
      iconLoading: false,
      form: {
        ...defaultForm,
      },
      rules: {
        name: [
          {
            required: true,
            message: "Required / Tên chức vụ không được bỏ trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    onChangePosition(checked) {
      if (checked) {
        this.$set(this.form, "status", "ACTIVE");
      } else {
        this.$set(this.form, "status", "DEACTIVE");
      }
    },
    createPosition() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form?.status
            ? this.form.status
            : this.$set(this.form, "status", "ACTIVE");
          this.iconLoading = true;
          this.$apollo
            .mutate({
              mutation: postQuery.queryCreatePosition,
              variables: {
                ...this.form,
              },
            })
            .then(({ data }) => {
              if (data?.createPosition) {
                this.$notification.success({
                  message: "Success",
                  description: "Updated Success!",
                });

                this.createdPositionOnView(data.createPosition);
                this.form = { ...defaultForm };
              }
              this.iconLoading = false;
            })
            .catch((error) => {
              this.$notification.error({
                message: "Error",
                description: "Updated Error!",
              });
              console.log("Không lấy được danh sách chức vụ", error);
              this.iconLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style></style>
